import { render, staticRenderFns } from "./EventTemplating.vue?vue&type=template&id=9323cdc8&"
import script from "./EventTemplating.vue?vue&type=script&lang=js&"
export * from "./EventTemplating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports